/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IAccessControlSegregator,
  IAccessControlSegregatorInterface,
} from "../IAccessControlSegregator";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "sig",
        type: "bytes4",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasAccess",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IAccessControlSegregator__factory {
  static readonly abi = _abi;
  static createInterface(): IAccessControlSegregatorInterface {
    return new utils.Interface(_abi) as IAccessControlSegregatorInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IAccessControlSegregator {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as IAccessControlSegregator;
  }
}
